import { render, staticRenderFns } from "./wechat_group_node_form.vue?vue&type=template&id=312c854a&"
import script from "./wechat_group_node_form.vue?vue&type=script&lang=js&"
export * from "./wechat_group_node_form.vue?vue&type=script&lang=js&"
import style0 from "./wechat_group_node_form.vue?vue&type=style&index=0&id=312c854a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports